import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { cardSectionHeader, cardSectionHeaderText } from '../../styles/pageStyles';

/**
 * Seção de configurações dentro de um card.
 * @param {React.Element} [icon]      ícone à esquerda do título (fontSize "small")
 * @param {string} title             título da seção (subtitle2)
 * @param {string} [description]     descrição curta (caption, text.secondary)
 * @param {React.Node} [action]      controle à direita do título (ex.: Switch de habilitar)
 * @param {React.Node} children      conteúdo da seção
 * @param {object} [sx]              sx extra no container
 */
export default function SettingsSection({ icon, title, description, action, children, sx }) {
  return (
    <Box sx={{ py: 2, '&:not(:last-of-type)': { borderBottom: '1px solid', borderColor: 'divider' }, ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: description ? 0.5 : 1.5 }}>
        <Box sx={{ ...cardSectionHeader, mb: 0, flex: 1, minWidth: 0 }}>
          {icon}
          <Typography {...cardSectionHeaderText}>{title}</Typography>
        </Box>
        {action}
      </Box>
      {description && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
          {description}
        </Typography>
      )}
      {children}
    </Box>
  );
}

SettingsSection.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node,
  sx: PropTypes.object,
};
